import React from "react";
// ----------------------------------------------
import AuthLoginForm from "./AuthLoginForm";
import AuthHeader from "../_components/AuthHeader";

import { enqueueSnackbar } from "notistack";
import { LoginData, LoginDataSchema } from "@/schemas/auth";
import { login, loginWithGoogle,checkEmailExists } from "@redux/slices/auth";
import { useNavigate } from "react-router";

export default function Login() {
  // ---STATE-----------------------------
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [data, setData] = React.useState<LoginData>({
    email: "",
    password: "",
  });
  const [otpCode, setOtpCode] = React.useState(""); // Add state for otpCode
  const [isOtpSent, setIsOtpSent] = React.useState(false); // Add state for isOtpSent
  const [IsPassword, setIsPassword] = React.useState(false);
  // ---HOOKS-----------------------------
  const navigate = useNavigate();

  // ---USE EFFECT-----------------------------
  React.useEffect(() => {
    setIsLoading(false);
    setError("");
  }, []);

  // ---HANDLERS-----------------------------
  const handleOnSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      // ---VALIDATE DATA-----------------------------
      LoginDataSchema.parse(data);

      // ---LOGIN USER-----------------------------
      await login(data.email, data.password, navigate).then(() => {
        setIsOtpSent(true); // Set isOtpSent to true after sending OTP
      }).finally(() => {
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      // ---HANDLE ZOD ERROR-----------------------------
      if (error?.errors?.[0]?.message) {
        setError(
          error.errors[0].message ===
            "String must contain at least 6 character(s)"
            ? "Password must have at least 6 characters"
            : error.errors[0].message
        );
        enqueueSnackbar(error.errors[0].message, { variant: "error" });
      }

      // ---HANDLE SUPABASE ERROR-----------------------------
      else {
        setError(error.message);
        enqueueSnackbar(error.message, { variant: "error" });
      }
    }
  };

  // ---GOOGLE SIGN IN-----------------------------
  const handleGoogleSignIn = async () => {
    try {
      setIsLoading(true);
      // ---SIGN IN WITH GOOGLE-----------------------------
      await loginWithGoogle();
    } catch (error) {
      console.error("error", error);
      enqueueSnackbar(error.message, { variant: "error" });
    }
  };


  const handleSendOtp = async () => {
    setIsLoading(true);
    setError("");


    
  
    try {
      // ---VALIDATE DATA-----------------------------
      // LoginDataSchema.parse(data);
  
      // ---LOGIN USER-----------------------------
      await login(data.email, data.password, navigate)
        .then(() => {
          setIsOtpSent(true); // Set isOtpSent to true after sending OTP
         
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error: any) {
      setIsLoading(false);
  
      // Check if the error is related to a user not being found
      if (error.message === "User not found.") {
        setError("The email you entered is not associated with an account.");
        enqueueSnackbar("The email you entered is not associated with an account.", { variant: "error" });
      } else {
        setError(error.message || "An error occurred during login.");
        // enqueueSnackbar(error.message || "An error occurred during login.", { variant: "error" });
      }
    }
  };

  return (
    <main className="bg-gradient h-[100vh] flex flex-col items-center justify-center">
      <AuthHeader />
      <AuthLoginForm
        handleOnSubmit={handleOnSubmit}
        isLoading={isLoading}
        data={data}
        error={error}
        setData={setData}
        handleGoogleSignIn={handleGoogleSignIn}
        otpCode={otpCode} // Pass otpCode
        setOtpCode={setOtpCode} // Pass setOtpCode
        isOtpSent={isOtpSent} // Pass isOtpSent
        navigate={navigate} // Pass navigate as a prop
        setIsPassword={setIsPassword}
        IsPassword={IsPassword}
        handleSendOtp={handleSendOtp}
      />
    </main>
  );
}
